export const DEPARTMENT_FORECAST_UPDATED_EVENT = "department-forecast-updated";

export function dispatchDepartmentForecastUpdated() {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(DEPARTMENT_FORECAST_UPDATED_EVENT));
}
